import React from 'react';
import { Link } from 'react-router-dom';

/**
 * This page is no longer used for email verification.
 * Verification is now handled inline on the sign-up page via a 6-digit code.
 * This route is kept to handle any old verification links that may still be clicked.
 */
const VerifyEmail = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        fontFamily: 'Arial, sans-serif',
        padding: '32px',
        textAlign: 'center',
      }}
    >
      <div style={{ fontSize: 48 }}>📧</div>
      <h2 style={{ color: '#1a1a2e', marginTop: 16 }}>Verification Method Updated</h2>
      <p style={{ color: '#555', maxWidth: 400, lineHeight: 1.6 }}>
        Email verification is now done by entering a 6-digit code directly on the
        sign-up page. Please return to sign-up and check your email for the code.
      </p>
      <Link
        to='/sign-up'
        style={{
          marginTop: 24,
          padding: '12px 28px',
          backgroundColor: '#2563eb',
          color: '#fff',
          borderRadius: 8,
          textDecoration: 'none',
          fontSize: 15,
        }}
      >
        Back to Sign Up
      </Link>
    </div>
  );
};

export default VerifyEmail;
